import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M11.29 8.71L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71c-.38-.39-1.02-.39-1.41 0z",
    fillRule: "evenodd"
  }],
  circles: []
};
var ExpandLessIcon = function ExpandLessIcon(props) {
  return renderIcon(props, iconType);
};

export { ExpandLessIcon };
//# sourceMappingURL=ExpandLessIcon.esm.js.map
